import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DeviceMobile, X, Export } from "@phosphor-icons/react";

const KEY = "uu_a2hs_dismissed";

const isIos = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const isStandalone = () =>
  window.navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

/** iOS Safari cannot fire beforeinstallprompt, so we show the Share → Add to Home Screen hint. */
export const AddToHome = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    if (!isIos() || isStandalone()) return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="a2hs-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-white/10 bg-[#0F172A] px-4 pb-[max(env(safe-area-inset-bottom),0.75rem)] pt-3 text-white shadow-2xl lg:hidden"
    >
      <div className="mx-auto flex max-w-2xl items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center bg-[#002FA7]">
          <DeviceMobile size={18} weight="bold" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Keep Unity &amp; Utility on your iPhone</p>
          <p className="mt-0.5 text-xs leading-relaxed text-slate-300">
            Tap <Export size={13} className="inline align-[-2px]" /> Share, then{" "}
            <span className="font-semibold text-white">Add to Home Screen</span>. It opens full screen, no App Store needed.
          </p>
          <Link
            to="/iphone"
            data-testid="a2hs-learn-more"
            onClick={() => { localStorage.setItem(KEY, "1"); setShow(false); }}
            className="tap-safe mt-1 text-xs font-semibold text-[#7FA0FF]"
          >
            See what works on the phone
          </Link>
        </div>
        <button
          type="button"
          data-testid="a2hs-dismiss"
          aria-label="Dismiss"
          onClick={() => { localStorage.setItem(KEY, "1"); setShow(false); }}
          className="flex h-10 w-10 shrink-0 items-center justify-center text-slate-400"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};
